export default "/fonts/PublicSans-Light.ttf?cb415ead2ba43a95bb380705d9200ae1";